import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';

type Options = {
  duration?: number;
};

export const useIncrement = (
  listLength: number,
  options: Options = {},
  isVisible: boolean = true
): [number, Dispatch<SetStateAction<number>>] => {
  const { duration = 5 } = options;
  const [currentIndex, setCurrentIndex] = useState(0);

  const increment = useCallback(() => {
    setCurrentIndex((prev) => (prev < listLength - 1 ? prev + 1 : 0));
  }, [listLength]);

  useEffect(() => {
    if (listLength > 0 && isVisible) {
      const timeoutId = setTimeout(increment, duration * 1000);
      return () => clearTimeout(timeoutId);
    }
  }, [listLength, currentIndex, increment, duration, isVisible]);

  return [currentIndex, setCurrentIndex];
};
